<template>
	<div>
		<el-container>
			<el-container>
				<el-main>
					<div class="search-box clearfix">
						<el-form class="form-main" ref="searchForm" :model="searchForm" size="mini" inline label-width="80px" label-position="right">
							<span>
								<el-form-item label="日期范围" property="dateRange">
									<span>
										<el-date-picker
											v-model="dateRange"
											type="monthrange"
											align="right"
											format="yyyy-MM"
											value-format="yyyy-MM"
											unlink-panels
											range-separator="至"
											start-placeholder="开始月份"
											end-placeholder="结束月份"
											@change="get_baobiao"
										/>
									</span>
								</el-form-item>
							</span>

							<div class="search-box-button search-button search_box_button_right">
							<el-button size="mini" type="primary" @click.native.prevent="get_baobiao">查 询</el-button>
							<el-button size="mini"  @click="resetSearchForm">重 置</el-button>
							</div>

						</el-form>
						</div>
						<hr class="search_border">
						<div class="search_tools_div">
						<div class="search_tools_text">数据列表
							<span style="margin-left: 15px">总条数： {{totalObj.totalCount ? totalObj.totalCount : 0 }}</span>
							<span style="margin-left: 15px">总发放配额： {{totalObj.totalMoney ? totalObj.totalMoney : 0 }}度</span>
						</div>
						<div class="search-tools">
							<el-button type="primary" @click="exportExcel">导出</el-button>
						</div>
					</div>
					<el-table
					  v-loading='loading'
					  ref="multipleTable"
					  :data="tableData"
					  tooltip-effect="dark"
					  :height="tableHeight"
					  border
					  stripe
					>
						<el-table-column prop="index" type="index" label="序号" align="center" width="80"></el-table-column>
						<el-table-column prop="period" label="月份" align="center"></el-table-column>
						<el-table-column prop="roomCount" label="房间数" align="center"></el-table-column>
						<el-table-column prop="quotaTotal" label="发放配额（度）" align="center"></el-table-column>
						<!-- <el-table-column
						  prop="icon"
						  fixed="right"
						  align="center"
						  label="操作">
							<template slot-scope="scope">
								<el-button v-if="scope.row.type != '充值'" type="text" @click="viewHandle(scope.row)">详情</el-button>
							</template>
						</el-table-column> -->
					</el-table>

					<!-- <el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  layout="total, sizes, prev, pager, next, jumper"
					  :page-sizes="[10, 20, 50, 100]"
					  :current-page="current"
					  :page-size="size"
					  :total="total">
					</el-pagination> -->
				</el-main>
			</el-container>
		</el-container>

	</div>
</template>

<script>
// 配额发放报表
import { getPeBaobiao } from '@/apis/orange'

export default {
	name: "Baobiaostu",	// 报表
	data() {
		return {
			nowDate: '',
			loading: false,
			searchForm: {},
			dateRange: [],
			dateRangeMoren: [],

			total: 0,
			size: 10,
			current: 1,

			tableData: [],
			totalObj: {}
		}
	},
	computed: {
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		}
	},
	created() {
		let t = new Date()
		let startMonth = t.getFullYear() + '-01'
		let endMonth = t.getFullYear() + '-' + ('0'+(t.getMonth() + 1)).slice(-2)
		let endDate = t.getFullYear() + '-' + ('0'+(t.getMonth() + 1)).slice(-2) + '-' + ('0' + t.getDate()).slice(-2)
		this.nowDate = endDate
		this.dateRange = [startMonth, endMonth]
		this.dateRangeMoren = [startMonth, endMonth]
		this.get_baobiao()
	},
	methods: {
		resetSearchForm() {
			this.searchForm = {}
			this.current = 1
			this.get_baobiao()
		},
		exportExcel() {
			const loading = this.$loading({
				text: '加载中...',
			});
			let searchObj = {}
			searchObj = JSON.parse(JSON.stringify(this.searchForm))
			let beginMonth = this.dateRange[0]?this.dateRange[0]:this.dateRangeMoren[0]
			let endMonth = this.dateRange[1]?this.dateRange[1]:this.dateRangeMoren[1]
			getPeBaobiao({...searchObj, beginMonth: beginMonth.replace('-', ''),
				endMonth: endMonth.replace('-', '')
			}).then(res => res.data).then(res => {
				this.tableData = res.data
				this.total = res.total.totalCount
				this.totalObj = res.total
				loading.close()
				if (res.code == 200) {
					if (res.data.length) {
						let excelData = res.data.map((it, index) => ({index: index + 1, month: it.period, roomCount: it.roomCount, quotaTotal: it.quotaTotal }))
						excelData.push({})
						excelData.push({})
						excelData.push({index: '', month: '合计', roomCount: res.total.totalCount, quotaTotal: res.total.totalMoney})
                        this.getExcel(excelData)
					} else {
						this.$message({
							type: 'error',
							message: "没有可导数据"
						})
					}
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		getExcel(excelData) {
            var XLSX = require("xlsx");

            // 创建一个工作表
            const worksheet = XLSX.utils.json_to_sheet(excelData)
            // 创建一个新的工作簿
            const workbook = XLSX.utils.book_new()

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Data')
            // 改写表头   'sku', 'wlms', 'ddsl', 'shsl', 'jhy'
            XLSX.utils.sheet_add_aoa(worksheet, [['序号', '月份', '房间数', '发放配额（度）']], { origin: 'A1' })
            XLSX.writeFileXLSX(workbook, `配额发放记录${this.nowDate}.xlsx`)
        },
		handleSizeChange(val) {
			this.size = val
			this.get_baobiao()
		},
		handleCurrentChange(val) {
			this.current = val
			this.get_baobiao()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.editForm = {}
		},
		get_baobiao() {
			this.loading = true
			let searchObj = {}
			searchObj = JSON.parse(JSON.stringify(this.searchForm))
			let beginMonth = this.dateRange[0]?this.dateRange[0]:this.dateRangeMoren[0]
			let endMonth = this.dateRange[1]?this.dateRange[1]:this.dateRangeMoren[1]
			getPeBaobiao({current: this.current, size: this.size, ...searchObj, beginMonth: beginMonth.replace('-', ''),
				endMonth: endMonth.replace('-', '')
			}).then(res => res.data).then(res => {
				this.loading = false
				this.tableData = res.data
				this.total = res.total.totalCount
				this.totalObj = res.total
			})
		},

	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}
.border {
	width: 40px;
	height:40px;
	text-align: center; 
	line-height: 40px;
	border-radius: 50%;
	display: inline-block;
	cursor: pointer;
}
.green {
	border: 1px solid green;
	color: green;
}
.red {
	border: 1px solid red;
	color: red;
}

</style>